import './App.scss';
import { AnimatePresence } from 'framer-motion';
import React,{Suspense,lazy} from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import useLocalStorageState from 'use-local-storage-state';
import data from './assets/data/allspark.json';
import { RedirectComponent} from './components';
import {
  PageLayout,
  HomePage,
} from './container';
import SplashScreen from './pages/SplashScreen/SplashScreen';
import RecapPage from './pages/recapPage/RecapPage';
import Loader from './components/Loader/Loader';
import ScannerPage from './pages/scannerPage/ScannerPage';
import ScreenSaver from './pages/screenSaver/ScreenSaver';
import RuntimePage from './pages/runtimePage/RuntimePage';

const GuestPage = lazy(()=> import('./container/guestPage/GuestPage'));
const RecapContainer = lazy(()=> import('./container/recapContainer/RecapContainer'));
const CommitteePage = lazy(()=> import('./container/committeePage/CommitteePage'));
const SpeakerPage = lazy(()=> import('./container/speakerPage/SpeakerPage'));
const SchedulePage = lazy(() => import('./container/SchedulePage/SchedulePage'));
const AboutPage = lazy(()=> import('./container/aboutPage/AboutPage'));

function App() {
  const [theme, setTheme] = useLocalStorageState('theme', {
    defaultValue: 'light',
  });
  const location = useLocation();
  function changeTheme() {
    setTheme(theme === 'light' ? 'dark' : 'light');
  }

  return (
    <AnimatePresence>
      <div className={`App ${theme}`}>
        <PageLayout theme={theme} handleTheme={changeTheme}>
          <Suspense fallback={<Loader theme={theme}/>}>
            <Routes location={location} key={location.pathname}>
              <Route path="/" exact element={<SplashScreen theme={theme} />}></Route>
              <Route path="/home" element={<HomePage details={data.categories}/>}></Route>
              <Route path="/guests" element={<GuestPage details={data.guests} />}></Route>
              <Route path="/speakers" element={<SpeakerPage speakerData={data.speakers} sessionData={data.sessions}/>}></Route>
              <Route path="/schedule" element={<SchedulePage agenda={data.agenda} events={data.events}/>}></Route>
              <Route path="/recap">
                  <Route index={true} element={<RecapContainer details={data.recap} />}></Route>
                  <Route index={false} path={"/recap/2016/"} element={<RecapPage path={"/recap/2016/index.html"}/>}></Route>
                  <Route index={false} path={"/recap/2017/"} element={<RecapPage path={"/recap/2017/index.html"}/>}></Route>
                  <Route index={false} path={"/recap/2018/"} element={<RecapPage path={"/recap/2018/index.html"}/>}></Route>
                  <Route index={false} path={"/recap/2019/"} element={<RecapPage path={"/recap/2019/index.html"}/>}></Route>
              </Route>
              <Route path="/committee" element={<CommitteePage details={data.committee}/>}></Route>
              <Route path="/about" element={<AboutPage url={data.about.embedURL} theme={theme}/>}></Route>
              <Route path="/scanner" element={<ScannerPage scanner={'barcode'} theme={theme}/>}></Route>
              <Route path="/screenSaver" element={<ScreenSaver theme={theme}/>}></Route>
              <Route path="/scan" element={<ScannerPage scanner={'qrcode'} theme={theme}/>}></Route>
              <Route path="/runtime" element={<RuntimePage theme={theme}/>}></Route>
              {/* Route to redirect to home for any invalid URL */}
              <Route path="*" element={<RedirectComponent />} />
            </Routes>
          </Suspense>
        </PageLayout>
      </div>
    </AnimatePresence>
  )
}

export default App;
